import { __awaiter } from "tslib";
import apis from '@/requests';
export const Options = {
    body: {
        clientVersion: [],
        consoleVersion: [],
        revenueTypes: [],
        contactTypes: [],
        cycleClosePreDay: [],
        farmMetadataTypes: [],
        calendarTypes: [],
        calendarEventLimit: [],
        calendarWriteFutureRefuseDays: []
    },
    inited(self) {
        self.contactTypes = self.contactTypes.filter(t => t.mode !== 'client');
    },
    loaders: {
        fetch(self, done, fail) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    let data = yield apis.config();
                    self.$init(data);
                    done();
                }
                catch (error) {
                    fail(error);
                }
            });
        }
    }
};
